//import { copyRichText } from './chatHelper';

// export const downloadMarkdownAsDocx = async (markdownText, filename = 'document.docx') => {
//     // Convert markdown to HTML
//     let RenderedHTML = await copyRichText(markdownText);

//     // Create a new document
//     const doc = new Document({
//         sections: [{
//             properties: {},
//             children: [
//                 new Paragraph({
//                     children: [
//                         new TextRun(RenderedHTML),
//                     ],
//                 }),
//             ],
//         }],
//     });

//     // Create blob
//     const blob = await Packer.toBlob(doc);

//     // Download the blob
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = filename;
//     a.click();
//     window.URL.revokeObjectURL(url);
// };

import { Resource } from "../types/resource";
import { useToast } from "../contexts/ToastContext";

const formatTextForDownload = (text: string) => {
  if (text.includes('<code')) {
    // Convert code blocks to markdown format
    return text.replace(/<code language="(\w+)".*?>([\s\S]*?)<\/code>/g, '```$1\n$2```');
  }
  return text;
};

export const useHandleDownloadResource = () => {
  const toast = useToast();

  const handleDownloadResource = (resource: Resource) => {
    if (resource.type === 'essay') {
      const formattedContent = formatTextForDownload(resource.content);
      downloadMarkdownFile(formattedContent, resource.title);
    } else if (resource.type === 'code') {
      if (!resource.language) {
        toast('No language specified for code resource', 'error');
        return;
      }
      downloadCodeFile(resource.content, resource.language, resource.title);
    }

    toast(
      `${resource.title.substring(0, 15)}${resource.title.length > 15 ? '...' : ''} Successfully Downloaded`,
      'success'
    );
  };

  return handleDownloadResource;
};

export const downloadCodeFile = (code: string, language: string, filename = 'code') => {
    const baseFilename = filename.split('.')[0];

    const extensionMap: Record<string, string> = {
      javascript: 'js',
      js: 'js',
      typescript: 'ts',
      ts: 'ts',
      jsx: 'jsx',
      tsx: 'tsx',
      python: 'py',
      py: 'py',
      java: 'java',
      c: 'c',
      cpp: 'cpp',
      'c++': 'cpp',
      cc: 'cpp',
      cxx: 'cpp',
      csharp: 'cs',
      'c#': 'cs',
      cs: 'cs',
      php: 'php',
      rb: 'rb',
      ruby: 'rb',
      swift: 'swift',
      go: 'go',
      golang: 'go',
      rust: 'rs',
      rs: 'rs',
      html: 'html',
      css: 'css',
      json: 'json',
      xml: 'xml',
      yml: 'yml',
      yaml: 'yaml',
      sql: 'sql',
      sh: 'sh',
      bash: 'sh',
      pl: 'pl',
      perl: 'pl',
      lua: 'lua',
      r: 'r',
      dart: 'dart',
      kt: 'kt',
      kotlin: 'kt',
      m: 'm',
      objc: 'm',
      scala: 'scala',
      md: 'md',
      txt: 'txt'
    };

    const langKey = language?.toLowerCase().trim() || '';
    const extension = extensionMap[langKey] || 'txt';

    const fullFilename = `${baseFilename}.${extension}`;

    const blob = new Blob([code], { type: 'text/plain' });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fullFilename;

    a.click();

    window.URL.revokeObjectURL(url);
};
  
export const downloadMarkdownFile = (content: string, title: string) => {
    const baseTitle = title.split('.')[0];
    
    const fullFilename = `${baseTitle}.md`;
  
    const blob = new Blob([content], { type: 'text/markdown' });
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fullFilename;
    
    a.click();
    
    window.URL.revokeObjectURL(url);
};
